import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { UsuarioService } from '../../shared/service/usuario/usuario.service';
import { Usuario, TokenInfo } from '../../shared/index';
import { UtilService } from '../../shared/service/util/util.service';

@Component({
    selector: 'app-usuario-reset-token',
    templateUrl: './usuario-reset-token.component.html',
    styleUrls: ['./usuario-reset-token.component.css']
})
export class UsuarioResetTokenComponent implements OnInit {

    public organizacaoId: number;
    public usuarioId: number;
    public usuario: Usuario;
    public nomeUsuario: string;
    public resetTokenDto: any = {};
    public cartaoSelecionado: boolean = false;
    public mobileidSelecionado: boolean = false;
    public tokenInfo: TokenInfo = new TokenInfo();
    public disabledSubmit: boolean = false;
    public showSpinner: boolean = false;

    constructor(private route: ActivatedRoute,
        private location: Location,
        private usuarioService: UsuarioService,
        private utilService: UtilService) {

        this.organizacaoId = JSON.parse(localStorage.getItem("currentUser")).organizacaoId;

        this.route.params.subscribe(params => {
            if (params["id"]) {
                this.showSpinner = true;
                this.usuarioId = params["id"];
                usuarioService.obterDadosUsuarioOrgPorId(this.usuarioId, this.organizacaoId).subscribe(
                    res => {
                        this.usuario = res;
                        this.nomeUsuario = this.usuario.nome;

                        this.obterToken();
                    }
                );
            }
        });
    }

    ngOnInit() {
    }

    obterToken() {
        this.usuarioService.obterTokenInfo(this.usuarioId, this.organizacaoId).subscribe(
            res => {
                this.tokenInfo.numeroCartao = res.numeroCartao;
                this.tokenInfo.possuiTokenCartao = res.possuiTokenCartao;
                this.tokenInfo.possuiTokenMobile = res.possuiTokenMobile;
                this.showSpinner = false;

                if (!this.tokenInfo.possuiTokenCartao && !this.tokenInfo.possuiTokenMobile) {
                    this.disabledSubmit = true;
                }
            }
        )
    }

    resetToken() {
        const selected = (this.cartaoSelecionado || this.mobileidSelecionado);

        if (selected) {
            this.showSpinner = true;
            this.resetTokenDto.tipos = [];
            this.cartaoSelecionado && this.resetTokenDto.tipos.push("CARTAO");
            this.mobileidSelecionado && this.resetTokenDto.tipos.push("MOBILEID");

            this.usuarioService.resetTokenUsuarioOrg(this.usuarioId, this.organizacaoId, this.resetTokenDto).subscribe(
                res => {
                    this.showSpinner = false;
                    this.utilService.showSuccess("e-Token redefinido com sucesso");
                    this.location.back();
                },
                err => {
                    this.showSpinner = false;
                    this.utilService.showError(err.message || "Falha no reset do e-Token");
                }
            );
        } else {
            this.utilService.showError("Selecione o e-Token que deseja redefinir");
        }
    }

    cancel() {
        this.location.back();
    }
}